import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';

import { orderSliceReducer } from 'app/pages/order/redux/order-slice';
import { authSliceReducer } from 'app/pages/auth/redux/auth-slice';
import { authPersistConfig } from 'app/redux/store/store-config';

export const rootReducer = combineReducers({
    auth: persistReducer(authPersistConfig, authSliceReducer),
    order: orderSliceReducer,
});
